// theme constant
export const gridSpacing = 3;
export const drawerWidth = 260;

// Fixed header height (48px toolbar + 2 x 16px padding) with the vertical menu
export const headerHeightVertical = 80;

// Fixed header + horizontal menu bar height with the horizontal menu
export const headerHeightHorizontal = 117;

// Padding below the headerHeight (vertical or horizontal) and the heading eg. Application Management
export const mainContentTopPadding = 0;

// White space to the left of the gray main content section
export const mainContentMarginLeft = 20;
// White space to the right of the gray main content section
export const mainContentMarginRight = 20;

export const appDrawerWidth = 320;
